<template>
    <div>
    <div class="title" :data-relevancy-score="relevancyScore" :data-cost-rating="costRating" :data-quality-rating="qualityRating">
        <div class="heading-style">
            <hp5-heading size-selection="md" tag-selection="h3">
                <hp5-link-text-basic :data-card-rank="rank" size="md" :href="url" :text="fullname" />
            </hp5-heading>
        </div>
        <div class="popover">
            <ResultsBaseLowCostRatingPopoverMessage :result="result"/>
        </div>
    </div>
    <hp5-spacing-vertical xs="xxs"></hp5-spacing-vertical>
</div>
</template>

<script setup>

    const props = defineProps({
        result: Object,
        rank: Number
    })

    // adding this info to data attributes so QA's can use the UI to test
    const relevancyScore = ref(props.result.relevancyScore)
    const costRating = props.result.costRating ? ref(props.result.costRating.value) : ''
    const qualityRating = props.result.qualityRating ?  ref(props.result.qualityRating.value) : ''


    const { context, betterChoiceContext } = useFCPModel()

    const { practitionerDetailUrl } = useUrls(context.value)
    const { name, locationId, practitionerId } = props.result

    const fullname = computed(() => {
      return (
        (name.first ? name.first : '') +
        ' ' +
        (name.middle ? name.middle : '') +
        ' ' +
        (name.last ? name.last : '') +
        (name.suffix ? ', ' + name.suffix : '') +
        (name.title ? ', ' + name.title : '')
      )
    }) 
    
    const url = computed(() => {
      if (locationId && practitionerId != null) {
        return practitionerDetailUrl(practitionerId, locationId, betterChoiceContext.value)
      }
    })

</script>

<style lang="scss">

.popover {
    font-family: var(--text-heading-font-md);
    grid-column: 2;
    grid-row: 1;
}
.heading-style{
    grid-column: 1;
    grid-row: 1;
}

    .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

</style>